module.exports = __webpack_public_path__ + "img/item-info-icon2_r.bc4368e2.svg";